const WA = 'https://wa.me/5555996946460?text=Olá,%20vim%20pelo%20Google%20e%20quero%20agendar%20consulta';

export default function CtaSection() {
  return (
    <section id="contato" className="py-24 bg-gradient-to-br from-[#4F5D4A] to-[#3D4A38] relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#6B705C]/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#C2A878]/10 rounded-full blur-3xl"></div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="w-10 h-[2px] bg-gradient-to-r from-[#6B705C] to-[#C2A878]"></div>
          <i className="ri-stethoscope-line text-[#C2A878] text-xl"></i>
          <div className="w-10 h-[2px] bg-gradient-to-l from-[#6B705C] to-[#C2A878]"></div>
        </div>
        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
          Sua saúde merece <span className="text-[#C2A878]">atenção</span>
        </h2>
        <p className="text-lg text-white/70 mb-10 max-w-2xl mx-auto">
          Cuide da sua saúde com um olhar mais humano e completo. Agende sua consulta e invista na sua qualidade de vida.
        </p>
        <a
          href={WA}
          onClick={(e) => {
            e.preventDefault();

            if (typeof gtag_report_conversion === 'function') {
              gtag_report_conversion(WA);
            } else {
              window.open(WA, '_blank');
            }
          }}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-[#6B705C] to-[#C2A878] text-white px-10 py-4 rounded-lg text-base font-bold hover:from-[#4F5D4A] hover:to-[#B39468] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl shadow-[#4F5D4A]/30"
        >
          <i className="ri-whatsapp-line text-xl"></i>Agendar Consulta
        </a>
      </div>
    </section>
  );
}